import { Header } from './Header';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    // The safe-area pads keep the header out from under the notch and the last
    // of a scrolled page off the home indicator, now that the viewport is
    // `viewport-fit=cover`. They are inside the `min-h-screen` box (Tailwind
    // makes everything border-box), so the page does not grow by them, and
    // they are zero on any screen without insets. See index.css.
    <div className="min-h-screen flex flex-col bg-linear-to-b from-background to-muted/30 pt-safe pb-safe px-safe">
      <Header />
      <main className="flex-1 flex flex-col">{children}</main>
    </div>
  );
}
